var newWindowWidth = $(window).width();
if (newWindowWidth < 768) {
    
$(".footer_content h6").click(function () {
   $(this).addClass('active1');
   if ($(".toggle_content").is(':visible')) {
        $(".toggle_content").slideUp(300);
        $(this).addClass('active1');
    }
   if ($(this).next(".toggle_content").is(':visible')) {
        $(this).next(".toggle_content").slideUp(300);
        $(this).addClass('active1');
    } else {
        $(this).next(".toggle_content").slideDown(300);
        $(this).removeClass('active1');
    }
});

}


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}